import "./App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import AutomotivePage from "./pages/AutomotivePage";
import MotorcyclePage from "./pages/MotorcyclePage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/automotive" element={<AutomotivePage />} />
        <Route path="/motorcycle" element={<MotorcyclePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
